import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core'
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { Country } from 'src/app/models/country.model';
import { QuoteService } from 'src/app/service/quote.service';
import { AddressModel, MemberModel, MetadataModel, PhoneModel, QuoteModel } from 'src/app/service/web-api-client';
import { ErrorModalComponent, ErrorModalData } from './error-modal.component';


function fakeEmailAsyncValidator(): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const email = control.value;

    return of(email).pipe(
      delay(500), // simulate async API call
      map(value => {
        const valid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        return valid ? null : { invalidEmail: true };
      })
    );
  };
}

@Component({
  selector: 'quote-step3',
  templateUrl: 'quote-step3.component.html',
  styleUrls: ['quote-step3.component.css'],
})

 

export class QuoteStep3Component implements OnDestroy {

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  progressBarPath: string = '/assets/external/Progress-bar.svg'
  progressBarTransparentPath: string = '/assets/external/Progress-bar-transparent.svg'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectoralt: string = 'Vector3387'
  vectoralt4: string = 'Vector3387'
  ballPink1src: string = '/assets/external/basketball-resize.png'
  ballPink1alt: string = 'BallPink13179'
  towerGrey: string = '/assets/external/tower-resize.png'
  plusFilled: string = '/assets/external/plusFilled.png'
  ballPink1srcNew: string = '/assets/external/newbasketball-resize.png'
  ballBlueSmall: string = '/assets/external/ballbluesmall-resize.png'
  towerNew: string = '/assets/external/tower-new-resize.png'


  stepThreeForm: FormGroup;
  submitted = false;
  isloading = false;
  isError = false;

  countries: Country[] = [];
  selectedCountry: Country | null;
  filterValue: string = '';

  // Error handling properties
  currentErrorData: ErrorModalData | null = null;
  errorFieldName: string = '';

  constructor(private quoteService: QuoteService, private fb: FormBuilder, private http: HttpClient) {
    this.createForm();
  }

  createForm() {
    this.http.get<Country[]>('/assets/countrycode/CountryCodes.json').subscribe(data => {
      this.countries = data.map(country => {
        return {
          name: country.name,
          code: country.code,
          phoneCode: country.phoneCode,
          flag: country.flag,
          id: country.phoneCode,
          text: country.name
        };
      });
    });
    this.stepThreeForm = this.fb.group({
      applicantName: ['', Validators.required],
      applicantLastName: ['', Validators.required],
      applicantEmail: ['', Validators.required, fakeEmailAsyncValidator()],
      phoneCode: [''],
      applicantPhone: [''],
      checkedMarketing: [false]
    });

    if (this.quoteService.quoteModel && this.quoteService.quoteModel.members) {
      this.stepThreeForm.controls.checkedMarketing.setValue(this.quoteService.quoteModel.agreedReceivingOffers);
      if (this.quoteService.quoteModel.members[0].firstName && this.quoteService.quoteModel.members[0].lastName &&
        this.quoteService.quoteModel.members[0].email) {
        this.stepThreeForm.controls.applicantName.setValue(this.quoteService.quoteModel.members[0].firstName)
        this.stepThreeForm.controls.applicantLastName.setValue(this.quoteService.quoteModel.members[0].lastName)
        this.stepThreeForm.controls.applicantEmail.setValue(this.quoteService.quoteModel.members[0].email)
        if (this.quoteService.quoteModel.members[0].phones.length > 0 && this.quoteService.quoteModel.members[0].phones[0].countryCode && this.quoteService.quoteModel.members[0].phones[0].phoneNumber) {
          this.stepThreeForm.controls.phoneCode.setValue(this.quoteService.quoteModel.members[0].phones[0].countryCode)
          this.stepThreeForm.controls.applicantPhone.setValue(this.quoteService.quoteModel.members[0].phones[0].phoneNumber)
        }
      }
    }
  }

  nextStep(): void {
    // El correo lleva un validador asincrono (500 ms): si se pulsa justo despues de escribir, el formulario esta
    // PENDING y antes se abortaba en silencio (habia que pulsar dos veces). Se espera a que resuelva y se reintenta.
    if (this.stepThreeForm.pending) {
      this.isloading = true;
      const sub = this.stepThreeForm.statusChanges.subscribe((status) => {
        if (status !== 'PENDING') {
          sub.unsubscribe();
          this.isloading = false;
          this.nextStep();
        }
      });
      return;
    }
    this.submitted = true;
    this.isloading = true;
    
    // Check if the form is valid before proceeding
    if (this.stepThreeForm.valid) {
      this.scheduleLoadingModal(); // segun el diseno: la ventana de espera solo si la cotizacion tarda mas de 1,5 s
      this.quoteService.quoteModel.agreedReceivingOffers = this.stepThreeForm.controls.checkedMarketing.value;
      if(!this.quoteService.quoteModel.members) {
        this.quoteService.quoteModel.members = [];  
        this.quoteService.quoteModel.members[0] = new MemberModel();
      }
      
      
      this.quoteService.quoteModel.members[0].memberTypeId = 1;
      this.quoteService.quoteModel.members[0].firstName = this.stepThreeForm.controls.applicantName.value;
      this.quoteService.quoteModel.members[0].lastName = this.stepThreeForm.controls.applicantLastName.value;
      this.quoteService.quoteModel.members[0].birthdate = this.quoteService.quoteModel.applicantBirthdate;
      this.quoteService.quoteModel.members[0].email = this.stepThreeForm.controls.applicantEmail.value;
      this.quoteService.quoteModel.members[0].isDependent = false;
      this.quoteService.quoteModel.members[0].phones = [];
      this.quoteService.quoteModel.members[0].phones[0] = new PhoneModel();
      this.quoteService.quoteModel.members[0].phones[0].countryCode = this.stepThreeForm.controls.phoneCode.value;
      this.quoteService.quoteModel.members[0].phones[0].phoneNumber = this.stepThreeForm.controls.applicantPhone.value;
      this.quoteService.quoteModel.members[0].phones[0].phoneTypeId = 1;
      
      const self = this;
      const setQuote = this.quoteService.quoteModel.number? this.quoteService.updateQuote$(this.quoteService.quoteModel) : this.quoteService.createQuote$(this.quoteService.quoteModel);
      
      setQuote.subscribe({
        next: (r) => {
          try {
            const resultJson = JSON.stringify(r);
            const result = JSON.parse(resultJson);
            self.quoteService.quoteModel = result;
            self.finishLoadingModal();
            setTimeout(() => {
              self.onNextStep.emit(self.currentStep);  
            }, 500);
            
            
          } catch (error) {
            console.error('🔍 Parsing or processing error:', error);
          } finally {
            this.isloading = false;
          }
        },
        error: (err) => {
          console.error('🔍 setQuote ERROR callback triggered!');
          console.error('🔍 Server error received:', err);
          console.error('🔍 Error type:', typeof err);
          console.error('🔍 Error keys:', Object.keys(err));
          console.error('🔍 Error.error:', err.error);
          console.error('🔍 Error.status:', err.status);
          console.error('🔍 Full error object:', JSON.stringify(err, null, 2));
          
          this.isloading = false;
          
          this.cancelLoadingTimer();
          // Hide the loading modal when error occurs with proper timing
          setTimeout(() => {
            this.hideLoadingModal();
          }, 100); // Small delay to ensure modal is fully shown
          
          this.handleBackendError(err);
        },
        complete: () => {
        }
      });
    } else {
      console.log('🔍 Form validation failed, stopping submission');
      this.isloading = false;
    }
  }

  /**
   * Handle form validation errors by showing appropriate error modal
   */
  private handleFormValidationErrors(): void {
    // Find the first invalid field
    const invalidControls = Object.keys(this.stepThreeForm.controls).filter(key => {
      const control = this.stepThreeForm.get(key);
      return control && control.invalid && control.errors;
    });

    if (invalidControls.length > 0) {
      const firstInvalidField = invalidControls[0];
      const fieldName = this.getFieldDisplayName(firstInvalidField);
      
      // Determine error type based on validation errors
      let errorCode = 'ERR.VAL.REQ';
      const control = this.stepThreeForm.get(firstInvalidField);
      
      if (control?.errors) {
        if (control.errors['required']) {
          errorCode = 'ERR.VAL.REQ';
        } else if (control.errors['invalidEmail']) {
          errorCode = 'ERR.VAL.INV';
        } else if (control.errors['min'] || control.errors['max']) {
          errorCode = 'ERR.VAL.INV';
        }
      }
      
      this.errorFieldName = fieldName;
      this.currentErrorData = this.createErrorModalData(errorCode, fieldName);
      
      // The error modal will automatically show when data is set
    }
  }
   jumpTpStep(step: number): void {
    document.getElementById('quoteLoadingModalToggle').click();
    this.onNextStep.emit(step);
  }
  prevStep(): void {
    // Clean up modals before going back
    this.cleanupAllModals();
    this.onPrevStep.emit(this.currentStep);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    // Clean up any open modals when leaving this component
    this.cleanupAllModals();
  }

  /**
   * Clean up all modals and modal artifacts when leaving the component
   */
  private cleanupAllModals(): void {
    try {
      // Immediate cleanup
      // Remove all modal backdrops (multiple selectors to catch all variations)
      const backdrops = document.querySelectorAll('.modal-backdrop, .modal-backdrop.fade, .modal-backdrop.show');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });
      
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      
      // Force reset body styles
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      
      // Hide any visible modals (DOM only)
      const visibleModals = document.querySelectorAll('.modal, .modal.show, .modal.fade');
      visibleModals.forEach(modal => {
        modal.classList.remove('show');
        (modal as HTMLElement).style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
      });

      // Note: We don't dispose Bootstrap instances here to avoid conflicts with component lifecycle
    } catch (error) {
      console.error('Error cleaning up modals:', error);
    }
  }

  get canContinue(): boolean {
    return this.stepThreeForm.valid && this.validateEmail(this.stepThreeForm.controls.applicantEmail.value);
  }

  private validateEmail(email: string): boolean {
    let res = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return res.test(email);
  }

  resetFunction(options: any) {
    options.reset();
    this.filterValue = '';
  }

  customFilterFunction(event: KeyboardEvent, options: any) {
    options.filter(event);
  }

  /**
   * Handle backend API errors
   */
  private handleBackendError(error: any): void {
    let errorCode = '';
    let propertyName = '';
    
    // Try to extract error code from different possible locations
    if (error?.error?.Errors && error.error.Errors.length > 0) {
      const firstError = error.error.Errors[0];
      errorCode = firstError.errorCode || '';
      propertyName = firstError.propertyName || '';
    } else if (error?.error?.errorCode) {
      errorCode = error.error.errorCode;
      propertyName = error.error.propertyName || '';
    } else if (error?.error?.message) {
      // Parse message to extract error code and field
      const message = error.error.message;
      if (message.includes('ERR.VAL.INV')) {
        errorCode = 'ERR.VAL.INV';
        if (message.includes('Birthdate')) {
          propertyName = 'Model.Members[0]';
        }
      }
    }
    
    // Fallback for HTTP status codes
    if (!errorCode) {
      if (error.status === 404) {
        errorCode = 'ERR.NOT_FOUND';
      } else if (error.status === 400) {
        errorCode = 'ERR.VAL.INV';
      } else if (error.status >= 500) {
        errorCode = 'ERR.GENERIC';
      }
    }
    
    if (errorCode) {
      this.errorFieldName = this.getFieldDisplayName(propertyName);
      this.currentErrorData = this.createErrorModalData(errorCode, propertyName);
      
      // Force change detection by creating a new object reference
      this.currentErrorData = { ...this.currentErrorData };
      
      // The error modal will automatically show when data is set
    } else {
      console.log('🔍 No error code found, using generic error');
      this.currentErrorData = this.createErrorModalData('ERR.GENERIC', '');
    }
  }

  /**
   * Create error modal data based on error code
   */
  private createErrorModalData(errorCode: string, fieldName: string): ErrorModalData {
    // Define error configurations based on backend team specifications
    const errorConfigs: { [key: string]: { title: string; buttonText: string; showSubMessage: boolean } } = {
      'ERR.GENERIC': {
        title: 'Algo inesperado ha ocurrido. Por favor, intenta de nuevo más tarde.',
        buttonText: 'Volver a intentarlo',
        showSubMessage: true
      },
      'ERR.NOT_FOUND': {
        title: 'No hemos podido encontrar lo que estás buscando. Verifica la información ingresada.',
        buttonText: 'Volver al inicio',
        showSubMessage: true
      },
      'ERR.VAL.REQ': {
        title: 'Este campo es obligatorio. Por favor, complétalo antes de continuar.',
        buttonText: 'Completar campos requeridos',
        showSubMessage: true
      },
      'ERR.VAL.INV': {
        title: 'El valor ingresado no es válido. Asegúrate de que el formato sea correcto.',
        buttonText: 'Revisar y corregir',
        showSubMessage: true
      },
      'ERR.VAL.NOT_EMPTY': {
        title: 'Este campo no puede estar vacío. Por favor, ingresa un valor.',
        buttonText: 'Completar campo',
        showSubMessage: true
      },
      'ERR.VAL.GR_THAN': {
        title: 'El valor debe ser mayor que el permitido. Corrige para continuar.',
        buttonText: 'Corregir valor',
        showSubMessage: true
      },
      'ERR.VAL.LS_THAN': {
        title: 'El valor debe ser menor que el permitido. Ajusta el campo antes de seguir.',
        buttonText: 'Modificar valor',
        showSubMessage: true
      }
    };
    
    const config = errorConfigs[errorCode] || errorConfigs['ERR.GENERIC'];
    
    const errorData: ErrorModalData = {
      errorCode: errorCode,
      title: config.title,
      buttonText: config.buttonText,
      subMessage: '',
      showSubMessage: config.showSubMessage
    };
    
    return errorData;
  }

  /**
   * Get display name for field names
   */
  private getFieldDisplayName(propertyName: string): string {
    const fieldMappings: { [key: string]: string } = {
      'Model.PlanId': 'Plan',
      'Model.Riders[0].RiderId': 'Rider',
      'Model.Members[0]': 'Información del Miembro',
      'Model.Members[0].birthdate': 'Fecha de Nacimiento',
      'Model.Members[0].firstName': 'Nombres',
      'Model.Members[0].lastName': 'Apellidos',
      'Model.Members[0].email': 'Correo Electrónico',
      'Model.Members[0].passportNumber': 'Número de Pasaporte',
      'Model.Members[0].countryId': 'País',
      'applicantName': 'Nombres',
      'applicantLastName': 'Apellidos',
      'applicantEmail': 'Correo Electrónico',
      'applicantPhone': 'Teléfono',
      'phoneCode': 'Código de País'
    };
    
    return fieldMappings[propertyName] || propertyName;
  }

  /**
   * Handle error modal action button clicks
   */
  onErrorActionClick(errorCode: string): void {
    // Hide the error modal
    const errorModal = document.getElementById('errorModal');
    if (errorModal) {
      const modalInstance = (window as any).bootstrap?.Modal?.getInstance(errorModal);
      if (modalInstance) {
        modalInstance.hide();

      }
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
    }
    
    // Execute appropriate action based on error code as per backend team specifications
    switch (errorCode) {
      case 'ERR.GENERIC':
        this.retryCurrentProcess(); // Retry the same failed process or reload the current page
        break;
      case 'ERR.NOT_FOUND':
        this.goToHomePage(); // Redirect user to the home page or restart the flow
        break;
      case 'ERR.VAL.REQ':
        this.focusOnField(); // Scroll to the empty required field and focus it
        break;
      case 'ERR.VAL.INV':
        // For birthdate validation errors, redirect to step 2 where the birthdate field is located
        if (this.errorFieldName === 'Información del Miembro' || 
            this.errorFieldName.includes('birthdate') || 
            this.currentErrorData?.title.includes('fecha de nacimiento')) {
          this.goToStep2ForBirthdateError();
        } else {
          this.focusOnField(); // Highlight the invalid field and show input guidance
        }
        break;
      case 'ERR.VAL.NOT_EMPTY':
        this.focusOnField(); // Auto-focus the field for user input
        break;
      case 'ERR.VAL.GR_THAN':
        this.focusOnField(); // Focus on the field and show allowed value rules
        break;
      case 'ERR.VAL.LS_THAN':
        this.focusOnField(); // Focus on the field and show allowed value rules
        break;
      default:
        this.retryCurrentProcess();
    }
  }

  /**
   * Go to step 2 for birthdate error and highlight the birthdate field
   */
  private goToStep2ForBirthdateError(): void {
    // Store error information in the quote service so step 2 can access it
    // We'll use a custom property in the service to avoid modifying the generated model
    this.quoteService.setLastError({
      errorCode: 'ERR.VAL.INV',
      fieldName: 'birthdate',
      message: 'La fecha de nacimiento ingresada no es válida. Verifica que la fecha sea correcta.',
      shouldHighlight: true
    });
    
    // Navigate to step 2
    this.onPrevStep.emit(2); // Go back to step 2
  }

  /**
   * Retry the current process
   */
  private retryCurrentProcess(): void {
    // For now, just reset the form and allow retry
    this.isloading = false;
    this.isError = false;
  }

  /**
   * Go to home page
   */
  private goToHomePage(): void {
    // Navigate to step 1 (home/quote start)
    this.jumpTpStep(1);
  }

  /**
   * Focus on the problematic field
   */
  private focusOnField(): void {
    // Map backend field names to form control names
    const fieldMappings: { [key: string]: string } = {
      'Model.PlanId': 'planId',
      'Model.Riders[0].RiderId': 'riderId',
      'Model.Members[0]': 'memberInfo',
      'Model.Members[0].birthdate': 'birthdate',
      'Model.Members[0].firstName': 'applicantName',
      'Model.Members[0].lastName': 'applicantLastName',
      'Model.Members[0].email': 'applicantEmail',
      'Model.Members[0].passportNumber': 'passportNumber',
      'Model.Members[0].countryId': 'countryId',
      'applicantName': 'applicantName',
      'applicantLastName': 'applicantLastName',
      'applicantEmail': 'applicantEmail',
      'applicantPhone': 'applicantPhone',
      'phoneCode': 'phoneCode'
    };
    
    const fieldName = this.errorFieldName;
    const controlName = fieldMappings[fieldName] || fieldName;
    
    // Focus on the field if it exists in the current form
    if (this.stepThreeForm.get(controlName)) {
      // Try to find the element by ID first
      let element = document.getElementById(controlName);
      
      // If not found by ID, try to find by name attribute
      if (!element) {
        element = document.querySelector(`[formControlName="${controlName}"]`);
      }
      
      // If still not found, try to find by the label text
      if (!element) {
        const labels = document.querySelectorAll('label');
        for (let i = 0; i < labels.length; i++) {
          const label = labels[i];
          if (label.textContent?.includes(fieldName)) {
            const forAttr = label.getAttribute('for');
            if (forAttr) {
              element = document.getElementById(forAttr);
              break;
            }
          }
        }
      }
      
      if (element) {
        // Scroll to the field
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Focus on the field after a short delay
        setTimeout(() => {
          element.focus();
          
          // Add a visual highlight effect
          element.classList.add('field-error-highlight');
          setTimeout(() => {
            element.classList.remove('field-error-highlight');
          }, 3000);
        }, 500);
      } else {
        // If we can't find the specific field, scroll to the form
        const form = document.querySelector('form');
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    } else if (fieldName === 'Información del Miembro' || fieldName.includes('birthdate')) {
      // For member-related errors, scroll to the form and show a general message
      const form = document.querySelector('form');
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        
        // Add a general highlight to the form
        form.classList.add('field-error-highlight');
        setTimeout(() => {
          form.classList.remove('field-error-highlight');
        }, 3000);
      }
    } else {
      // If we can't find the specific field, scroll to the form
      const form = document.querySelector('form');
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  /** Ventana "Estamos creando tu cotizacion": se programa a los 1,5 s de enviar y solo aparece si la respuesta aun no llego */
  private loadingTimer: any = null;
  private loadingShownAt: number = 0;
  private scheduleLoadingModal(): void {
    this.cancelLoadingTimer();
    this.loadingTimer = setTimeout(() => { this.loadingTimer = null; this.showLoadingModal(); }, 1500);
  }
  private cancelLoadingTimer(): void {
    if (this.loadingTimer) { clearTimeout(this.loadingTimer); this.loadingTimer = null; }
  }
  private showLoadingModal(): void {
    const el = document.getElementById('quoteLoadingModal');
    if (!el) { return; }
    this.loadingShownAt = Date.now();
    const M = (window as any).bootstrap?.Modal;
    if (M && M.getOrCreateInstance) {
      M.getOrCreateInstance(el, { backdrop: 'static', keyboard: true }).show();
    } else {
      document.getElementById('quoteLoadingModalToggle')?.click();
    }
  }
  /** Al llegar la respuesta: cancela la ventana si no llego a mostrarse; si se mostro, la deja al menos 0,7 s para que no parpadee */
  private finishLoadingModal(): void {
    this.cancelLoadingTimer();
    const el = document.getElementById('quoteLoadingModal');
    if (!el || !el.classList.contains('show')) { return; }
    const wait = Math.max(0, 700 - (Date.now() - this.loadingShownAt));
    setTimeout(() => this.hideLoadingModal(), wait);
  }

  /**
   * Hide the loading modal using multiple approaches for maximum compatibility
   */
  private hideLoadingModal(): void {
    const loadingModal = document.getElementById('quoteLoadingModal');
    if (!loadingModal) {
      return;
    }

    // Method 1: Try Bootstrap Modal API
    try {
      const modalInstance = (window as any).bootstrap?.Modal?.getInstance(loadingModal);
      if (modalInstance) {
        modalInstance.hide();
        return;
      }
    } catch (error) {
      console.log('🔍 Bootstrap Modal API failed:', error);
    }

    // Method 2: Try clicking the hidden toggle button (same way it was shown)
    try {
      const toggleButton = document.getElementById('quoteLoadingModalToggle');
      if (toggleButton) {
        toggleButton.click();
        return;
      }
    } catch (error) {
    }

    // Method 3: Manual DOM manipulation as fallback
    try {
      // Hide the modal
      loadingModal.style.display = 'none';
      loadingModal.classList.remove('show');
      loadingModal.setAttribute('aria-hidden', 'true');
      
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
      // Remove backdrop
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      
      // Remove any remaining modal-related classes
      document.body.classList.remove('modal-open');
    } catch (error) {
      console.error('🔍 All modal hiding methods failed:', error);
    }
  }
}
